import ActionTypes from "../Actions/ActionTypes";

const initialState = {
  pages: [],
  lot_numbers: [],
};

const PagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PAGES:
      state = { ...state, pages: action.payload };
      break;
    case ActionTypes.GET_LOT_NUMBER:
      state = { ...state, lot_numbers: action.payload };
      break;
    default:
      break;
  }
  return state;
};
export default PagesReducer;
